import { render, staticRenderFns } from "./MaterialsChangeData.vue?vue&type=template&id=0895b856&scoped=true"
import script from "./MaterialsChangeData.vue?vue&type=script&lang=js"
export * from "./MaterialsChangeData.vue?vue&type=script&lang=js"
import style0 from "./MaterialsChangeData.vue?vue&type=style&index=0&id=0895b856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895b856",
  null
  
)

export default component.exports